/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TenantDetails } from 'app/page-modules/tenant-management/models';
import { State } from 'app/main/store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromTenantManagement from 'app/page-modules/tenant-management/store/tenant-management.selectors';
import { CreateTenantDetails } from 'app/page-modules/tenant-management/store/api/tenant-management-api.actions';
import { HideTenantCreationWizard } from 'app/page-modules/tenant-management/store/tenant-management.actions';

@Component({
  selector: 'og-tenant-creation-wizard',
  templateUrl: './tenant-creation-wizard.component.html',
  styleUrls: ['./tenant-creation-wizard.component.scss'],
  standalone: false
})
export class TenantCreationWizardComponent {
  coreTenantDetails: FormGroup;
  tenantDetails: TenantDetails;

  tenantCreationInProgress$: Observable<boolean>;

  constructor(private store: Store<State>, fb: FormBuilder) {
    this.coreTenantDetails = fb.group({
      name: ['', Validators.required],
      organizationId: ['', Validators.required]
    });

    this.tenantCreationInProgress$ = store.pipe(
      select(fromTenantManagement.isTenantCreationInProgress)
    );
  }

  onTenantNameChange(name: string): void {
    this.coreTenantDetails.setValue({ name });
  }

  onTenantOrganizationIdChange(organizationId: string): void {
    this.coreTenantDetails.setValue({ organizationId });
  }

  onFormSubmitted(): void {
    this.store.dispatch(new CreateTenantDetails(this.tenantDetails));
  }

  onWizardCancelled(): void {
    this.store.dispatch(new HideTenantCreationWizard());
  }
}
